import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87730088"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container container-xs main-wrap h-100" }
const _hoisted_2 = { class: "p-5 main-body" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-3\" data-v-87730088> [受検する]ボタンを押して受検を開始してください。 <br data-v-87730088>※模擬試験問題が画面に表示された時点から試験時間を計測します。 <br data-v-87730088>※試験時間が経過すると模擬試験は自動的に終了します。また、この模擬試験においては画面右下の[終了]ボタンによって終了することもできます。<br data-v-87730088> ※電卓使用を前提とした問題です。<br data-v-87730088><span class=\"text-danger\" data-v-87730088>※受検中、以下の行為を行うとエラーとなりますのでご注意ください。</span><ul data-v-87730088><li class=\"text-danger\" data-v-87730088>ブラウザの戻るボタンをクリック</li><li class=\"text-danger\" data-v-87730088>ページの再読み込み</li><li class=\"text-danger\" data-v-87730088>タブを消去し、開き直す行為</li></ul></div>", 1)
const _hoisted_4 = { class: "px-4 mb-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "試験一覧", -1))
const _hoisted_6 = { class: "basic-table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "試験名"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center",
    style: {"width":"200px"}
  }, "操作")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "計数 図表の解読（40問・35分）", -1))
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "計数 表の空欄（35問・35分）", -1))
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "計数 四則逆算（50問・９分）", -1))
const _hoisted_13 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", _hoisted_9, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exec(1)))
              }, "受検する")
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exec(2)))
              }, "受検する")
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("td", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exec(3)))
              }, "受検する")
            ])
          ])
        ])
      ])
    ])
  ]))
}